/**
 * Resolve IsAdvanced for compiled schema conditions (`with (context) return IsAdvanced`).
 * Used by utils.schema.getConditionContext so PropertyGrid2 / form2 leaves do not throw.
 *
 * Never read `instance.IsAdvanced` on a Vue component that does not declare it —
 * Vue 3 warns "Property IsAdvanced was accessed during render but is not defined".
 *
 * @param {object|null} control  Vue instance (or stand-in) that may own IsAdvanced
 * @param {object|null} data     optional bag passed to getConditionContext
 * @returns {boolean}
 */
export function resolveConditionIsAdvanced(control, data) {
    if (data && Object.prototype.hasOwnProperty.call(data, 'IsAdvanced'))
        return toBooleanFlag(data.IsAdvanced);

    let cur = control;
    while (cur) {
        const declared = readDeclaredIsAdvanced(cur);
        if (declared.found)
            return declared.value;
        cur = cur.$parent;
    }
    // PropertyGrid and createDefaultModel should include advanced fields.
    return true;
}

/**
 * @param {object} cur
 * @returns {{ found: boolean, value?: boolean }}
 */
function readDeclaredIsAdvanced(cur) {
    if (!cur || typeof cur !== 'object')
        return { found: false };

    // Vue instance: only declared props / computed (avoids render-time missing-prop warn).
    if (cur.$props || cur.$options) {
        if (cur.$props && Object.prototype.hasOwnProperty.call(cur.$props, 'IsAdvanced'))
            return { found: true, value: toBooleanFlag(cur.$props.IsAdvanced) };
        if (cur.$options?.computed && Object.prototype.hasOwnProperty.call(cur.$options.computed, 'IsAdvanced'))
            return { found: true, value: toBooleanFlag(cur.IsAdvanced) };
        return { found: false };
    }

    if (Object.prototype.hasOwnProperty.call(cur, 'IsAdvanced'))
        return { found: true, value: toBooleanFlag(cur.IsAdvanced) };
    return { found: false };
}

function toBooleanFlag(v) {
    if (v && typeof v === 'object' && 'value' in v)
        return !!v.value;
    return !!v;
}
